<template>
    <div :class="prefixCls" class="">
        <el-dropdown v-if="getUserName" popper-class="common-popper" >
            <div class="avatar"></div>
            <template #dropdown>
                <el-dropdown-menu show>
                    <el-dropdown-item command="logout" @click="logoutAction">{{ t('common.logout') }}</el-dropdown-item>
                </el-dropdown-menu>
            </template>
        </el-dropdown>
        <template v-else>
            <div class="common-btn-1 p-x-18 p-y-6 rounded-6 cursor-pointer text-#000 text-12 font-500" @click="loginAction">
                <span>{{ t('common.login') }}/{{ t('common.register') }}</span>
            </div>
        </template>
    </div>
    <DialogInformation :type="type" @close="() => (type = undefined)" />
    <Dialog v-model:dialogVisible="isShowRegister" width="700px" :title="t('register.title')" class="register-dialog">
        <Register @after-register="loginAction" @cancel="handleCancel" v-if="isShowRegister" />
    </Dialog>
</template>

<script lang="tsx" setup>
import { useI18n } from 'vue-i18n';
import { logout } from '@/apis/login';
import DialogInformation from '@/views/ServiceAgreement/components/DialogInformation.vue';
import { LOGIN_PATH } from '@/router/config';
import { useDesign } from '@/hooks/web/useDesign';
import { DialogContentType } from '@/views/ServiceAgreement/config';
import Register from '@/views/Login/components/Register.vue';
import Dialog from '@/components/Dialog.vue';
import { USER_CENTER } from '@/router';
import { getType } from '@/utils/global';

const { t } = useI18n();
const { push } = useRouter();
const { clearUserInfo, getUserName, getRole } = useStore('user');
const { getPrefixCls } = useDesign();
const prefixCls = getPrefixCls('user');
const type = ref();
const isShowRegister = ref(false);
const openContent = (contentType: DialogContentType) => {
    type.value = contentType;
};

const gotoUser = () => {
    const type = getType();
    push({ path: USER_CENTER, query: { type } });
};
const gotoGuide = () => {
    openContent(DialogContentType.USER_GUIDE);
};
const quitRequest = async () => {
    await logout();
    clearUserInfo();
    push(LOGIN_PATH);
};
const logoutAction = async () => {
    await quitRequest();
};
const loginAction = () => {
    setTimeout(() => {
        push(LOGIN_PATH);
    }, 1000);
};
const register = () => {
    isShowRegister.value = true;
};
const handleCancel = () => {
    isShowRegister.value = false;
};
function gotoApproval() {
    push('approval')
}
</script>

<style scoped lang="scss">
$prefix-cls: $self-namespace + '-user';

.#{$prefix-cls} {
    .avatar {
        width: 24px;
        height: 24px;
        background: url('@/assets/svgs/avatar.svg') no-repeat center 100% / 100%;

        // &:hover {
        //     background: url('@/assets/svgs/avatar-hover.svg') no-repeat center 100% / 100%;
        // }

        // &:active {
        //     background: url('@/assets/svgs/avatar-click.svg') no-repeat center 100% / 100%;
        // }
    }

    :deep(.el-tooltip__trigger) {
        &:focus-visible {
            outline: none !important;
        }
    }

    :deep(.el-icon) {
        &:focus {
            outline: none;
        }
    }

    :deep(.el-button) {
        &.is-plain {
            --el-button-hover-bg-color: transparent;
            --el-button-bg-color: transparent;
            --el-button-text-color: #fff;
            --el-button-border-color: #fff;
            padding: 4px 24px;
        }
    }
}
</style>
